// hooks
import { useCurrentUser } from 'hooks/index'
// types
import { IPlan, IPlanAction, IPlanKpi, IPlanObjective } from 'types/graphql'
// utils
import { isCurrentUser } from 'utils/user'

export const useFieldAccess = (entity: IPlan | IPlanAction | IPlanKpi | IPlanObjective) => {
  const user = useCurrentUser()

  if (!entity) {
    return false
  }

  const membersUsersIds = entity.memberUsers.map(({ id }) => id)
  const memberPositionsIds = entity.memberPositions.map(({ id }) => id)

  const ids = [entity.ownedById, ...memberPositionsIds, ...membersUsersIds]

  return ids.some(id => isCurrentUser(id, user))
}
